import httpClient from './httpClient';

const PASSWORD_ENDPOINTS = {
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESEND_OTP: '/auth/resend-verification',
  RESET_PASSWORD: '/auth/reset-password'
};

interface ForgotPasswordResponse {
  success: boolean;
  message: string;
}

interface ResendOTPResponse {
  success: boolean;
  message: string;
}

interface ResetPasswordResponse {
  success: boolean;
  message: string;
}

/**
 * Password Reset Service Layer
 * Handles forgot password, OTP verification, and password reset flow
 */
export const passwordService = {
  /**
   * Request OTP for password reset
   * @param email - User email address
   * @returns Response with success message
   */
  forgotPassword: async (email: string): Promise<ForgotPasswordResponse> => {
    const response = await httpClient.post<ForgotPasswordResponse>(
      PASSWORD_ENDPOINTS.FORGOT_PASSWORD,
      { email }
    );
    return response;
  },

  /**
   * Resend OTP for password reset
   * @param email - User email address
   * @returns Response with success message
   */
  resendOTP: async (email: string): Promise<ResendOTPResponse> => {
    const response = await httpClient.post<ResendOTPResponse>(
      PASSWORD_ENDPOINTS.RESEND_OTP,
      { email }
    );
    return response;
  },

  /**
   * Reset password with OTP verification
   * @param email - User email address
   * @param verificationCode - 6-digit OTP
   * @param newPassword - New password
   * @returns Response with success message
   */
  resetPassword: async (
    email: string,
    verificationCode: string,
    newPassword: string
  ): Promise<ResetPasswordResponse> => {
    const response = await httpClient.post<ResetPasswordResponse>(
      PASSWORD_ENDPOINTS.RESET_PASSWORD,
      {
        email,
        verificationCode,
        newPassword
      }
    );
    return response;
  }
};
